import { Button, Callout, Link } from '@dev-spendesk/grapes';

import { useAccountingSoftwareName } from 'src/core/modules/accounting-integration/apis';

import { useTranslation } from '../../../../common/hooks/useTranslation';

type Props = {
  /**
   *
   */
  onToMappingClick: () => void;
  isAlert?: boolean;
};

/**
 * PayableUnmappedAnalyticalFieldCallout is meant to be displayed for
 * cost centers and other custom fields which aren't mapped to the user's accounting integration yet.
 */
export const PayableUnmappedAnalyticalFieldCallout = ({
  onToMappingClick,
  isAlert = false,
}: Props) => {
  const { t } = useTranslation('global');
  const { accountingSoftwareName } = useAccountingSoftwareName();

  const title = t('bookkeep.export.modals.unmappedFieldValue.title', {
    integration: accountingSoftwareName,
  });

  return (
    <Callout
      className="my-8 mt-4"
      title={title}
      variant={isAlert ? 'alert' : 'warning'}
    >
      <div className="flex flex-row gap-8">
        <Button
          variant="secondaryNeutral"
          text={t('bookkeep.export.modals.unmappedFieldValue.toMappingAction')}
          onClick={onToMappingClick}
        />
        <Link href="#" isExternal>
          {t('bookkeep.export.modals.unmappedFieldValue.helpCenter')}
        </Link>
      </div>
    </Callout>
  );
};
